<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input ttLabel="stockplace_name" [ttModel]="setting.stockplace_name" ttReadonly></tt-input>
            <tt-input ttLabel="operation_name" [ttModel]="setting.operation_name" ttReadonly></tt-input>

            <form class="form-horizontal sp-0" name="formPaperlessPoOrderSearch" novalidate (ngSubmit)="searchOrders()" method="get" role="form">
                <tt-input ttLabel="ordersearch" ttFocus="false" [(ttModel)]="setting.ordersearch" (ttModelChange)="onChanged($event, 'ordersearch')" ttShowClearButton [ttButtons]="orderSearchButtons"></tt-input>
            </form>

            <form class="form-horizontal sp-0" name="formPaperlessPoProductSearch" novalidate (ngSubmit)="searchProductOrders()" method="get" role="form">
                <tt-input ttLabel="prodsearch" ttFocus="false" [(ttModel)]="setting.prodsearch" (ttModelChange)="onChanged($event, 'prodsearch')" ttShowClearButton [ttButtons]="productSearchButtons"></tt-input>
            </form>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto ttText="paperlesspo_create_new" ttGoto="pocreate" [ttGotoParms]="{ stock_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
